export const isLoggedIn = () => {
  const user = localStorage.getItem("user");
  const userObject = user ? JSON.parse(user) : {};
  return userObject && userObject.token;
};

export const logout = () => {
  localStorage.removeItem("user");
  window.location.reload();
};

export const getUser = () => {
  const user = localStorage.getItem("user");
  if (user) {
    return JSON.parse(user);
  }
};

export const getUserToken = () => {
  const user = getUser();
  return user && user.token ? user.token : "";
};
export const setUser = user => {
  localStorage.setItem("user", JSON.stringify(user));
  return true;
};

export const setUserToken = token => {
  const user = getUser();
  user.token = token;
  localStorage.setItem("user", JSON.stringify(user));
  return true;
};

export const setUserInfo = (key, value) => {
  const user = getUser();
  user[key] = value;
  localStorage.setItem("user", JSON.stringify(user));
  return true;
};

export const deleteUser = () => {
  localStorage.removeItem("user");
};

export const getUserInfo = key => {
  const user = getUser();
  return (user && user[key]) || "";
};
